import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportesService } from 'src/app/services/reportes/reportes.service';
import { ChartOptions } from 'chart.js';
import * as Chart from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';


@Component({
  selector: 'app-dependencias',
  templateUrl: './dependencias.component.html',
  styleUrls: ['./dependencias.component.css']
})
export class DependenciasComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart!: BaseChartDirective;
  companies = [];
  activos = [];
  filtrados = [];
  dependencia = '';
  creditCols = [
    {field: 'credit_folio', header: 'Folio', moneda: false} ,
    {field: 'name', header: 'Cliente', moneda: false} ,
    {field: 'business_name', header: 'Empresa', moneda: false} ,
    // {field: 'status', header: ''} ,
    {field: 'total_requested', header: 'Total solicitado', moneda: true} ,
    // {field: 'capital', header: ''} ,
    // {field: 'interests', header: ''} ,
    // {field: 'iva', header: ''} ,
    {field: 'total_debt', header: 'Deuda total', moneda: true} ,
    {field: 'plazo', header: 'Plazo', moneda: false} ,
    // {field: 'term_type', header: ''} ,
  ];

  currentPage: number = 1;
  itemsPerPage: number = 5;
  searchTerm: string = '';
  filaSeleccionada: number | null = null;

  chartColors = [
    '#007bff',
    '#6f42c1',
    '#20c997',
    '#fd7e14',
    '#d63384',
    '#198754',
    '#0dcaf0',
    '#e83e8c',
    '#6610f2',
    '#0d6efd',
    '#1982c4',
    '#ff595e',
    '#ffca3a',
    '#8ac926',
    '#6a4c93',
    '#ff9f1c',
    '#2ec4b6',
    '#4cc9f0',
    '#b5179e',
    '#7209b7',
    '#3a0ca3',
];

  pieChartLabels: string[] = [];
  pieChartData: number[] = [];
  pieChartColors: any[] = [];
  pieChartType = 'pie';
  pieChartOptions = {};
  pieChartPlugins = [pluginDataLabels];
  pages: (string | number)[];

  constructor(private reportesService: ReportesService) { }

  ngOnInit(): void {
    this.portafolioByCompany();
    this.creditosActivosByCompany();
  }

  creditosActivosByCompany() {
    this.reportesService.creditosActivosByCompany().subscribe( resp => {
      this.activos = JSON.parse(JSON.stringify(resp));
      this.pages = this.generatePages();
    });
  }

  portafolioByCompany() {
    this.reportesService.totalPortafolioByCompany().subscribe( resp => {
      this.companies = JSON.parse(JSON.stringify(resp));
      this.generarGrafica();
    });
  }

  generarGrafica() {
    this.pieChartLabels = this.companies.map(c => c.business_name);
    this.pieChartData = this.companies.map(c => Number(c.total_portfolio));

    this.pieChartColors = [{
      backgroundColor: this.companies.map((c, i) => this.chartColors[i % 7])
    }];

    this.pieChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          formatter: (value, context) => {
            const dataset = context.chart.data.datasets[0].data;

            // Convertir todos a número para evitar NaN
            const numericDataset = dataset.map(x => Number(x));

            const total = numericDataset.reduce((a, b) => a + b, 0);

            if (!total || isNaN(total)) return '0%';
            if (!value || isNaN(Number(value))) return '0%';

            const porcentaje = ((Number(value) / total) * 100).toFixed(1) + '%';
            return porcentaje;
          },
          color: '#fff',
          font: {
            size: 14,
            weight: 'bold'
          }
        }
      }
    };
  }

  filtrarCompany(company){
    if(company === this.dependencia){
      this.dependencia = '';
      this.filtrados = [];
      return;
    }
    this.dependencia = company;
    this.filtrados = this.activos.filter( c => c.business_name.toLowerCase() === company.toLowerCase() );
      setTimeout(() => {
      this.chart?.chart?.update();
    }, 150);
  }

    get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredData.slice(startIndex, startIndex + this.itemsPerPage);
  }

  get filteredData(): any[] {

    return this.filtrados.filter(item =>
      item.credit_folio.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      item.customer_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      item.company_name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  seleccionarFila(index: number, currentPage: number, itemsPerPage: number) {
    this.filaSeleccionada = index + (currentPage - 1) * itemsPerPage;
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  /* get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  } */

  pgone() {
    this.currentPage = 1;
    this.filaSeleccionada = -1;
  }

  generatePages(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    const delta = 2; // cantidad de páginas alrededor de la actual
    const pages: (number | string)[] = [];

    // helper para agregar páginas evitando duplicados
    const add = (p: number | string) => {
      if (!pages.includes(p)) pages.push(p);
    };

    add(1);

    // páginas cercanas a la actual
    for (let i = current - delta; i <= current + delta; i++) {
      if (i > 1 && i < total) add(i);
    }

    add(total);

    // insertar ...
    const finalPages: (number | string)[] = [];
    let prev: number | string | null = null;

    pages
      .sort((a, b) => Number(a) - Number(b))
      .forEach((p) => {
        if (prev !== null && Number(p) - Number(prev) > 1) {
          finalPages.push("...");
        }
        finalPages.push(p);
        prev = p;
      });

    return finalPages;
  }

}
